import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { useSnackbar } from "src/App/App.hooks.ts";
import { useMutation } from "@tanstack/react-query";
import { useExonnApi } from "src/exonn-api/exonn-api.tsx";
import { Flex } from "src/components/Flex.tsx";
import NiceModal from "@ebay/nice-modal-react";
import { ModalIDEnum } from "src/lib/nice-modal-react/nice-modal-react.ts";
import { SwitchV2 } from "src/components/SwitchV2/SwitchV2.tsx";
import { ControlLabelV2 } from "src/components/ControlLabelV2/ControlLabelV2.tsx";

import { appStore } from "src/stores/app.store.ts";
import { observer } from "mobx-react-lite";

export const DebugTab = observer(() => {
  const snackbarStore = useSnackbar();
  const api = useExonnApi();
  const { mutate: flushUserData } = useMutation({
    mutationFn: () => {
      return api.userData.flushUserData();
    },
  });
  function triggerChunkError() {
    NiceModal.show(ModalIDEnum.PreloadError);
  }

  return (
    <div
      style={{
        padding: 10,
      }}
    >
      <Flex flexDirection="column" gap={"15px"}>
        <div>
          <ButtonV2
            onClick={() => {
              snackbarStore.info({
                message: "Clearing user data...",
                flash: true,
              });
              flushUserData(undefined, {
                onSuccess: () => {
                  snackbarStore.success({
                    message: "User data has been successfully cleared",
                    flash: true,
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                },
              });
            }}
            startAdornment={<i className={"icon-15-trash"} />}
            size={"sm"}
          >
            Clear user data
          </ButtonV2>
        </div>
        <div>
          <ButtonV2 size={"sm"} onClick={triggerChunkError}>
            Trigger vite:preloadError
          </ButtonV2>
        </div>
        <div>
          <ControlLabelV2
            control={
              <SwitchV2
                checked={appStore.debugDbQueries}
                onChange={(event) => {
                  appStore.setDebugDbQueries(event.currentTarget.checked);
                }}
              />
            }
            label={"Debug database queries"}
          />
        </div>
        <div>
          <ControlLabelV2
            control={
              <SwitchV2
                checked={appStore.debugTranslations}
                onChange={(event) => {
                  appStore.setDebugTranslations(event.currentTarget.checked);
                }}
              />
            }
            label={"Debug translations"}
          />
        </div>
      </Flex>
    </div>
  );
});
